export const UPDATE_USER_CHOICES = "UPDATE_USER_CHOICES";
export const CLEAR_USER_CHOICES = "CLEAR_USER_CHOICES";
export const SET_LOADING = "SET_LOADING";
export const SET_FIREBASE_STATIC_DATA = "SET_FIREBASE_STATIC_DATA";
export const SET_ALERT = "SET_ALERT";
